import React, { useRef, useState } from "react";
import "./index.less";
import { ResourceListItem } from "@/types/base";
import ResourceOverviewCard from "./Card";
import { Button } from "antd";

interface ResourceOverviewListProps {
  data: ResourceListItem;
}

const prefix = "resource-overview-list";
const ResourceOverviewList: React.FC<ResourceOverviewListProps> = (props) => {
  const { data } = props;
  const elementIdPrefix=`resource-overview-card-${data.id}-`;
  const [currentIndex,setCurrentIndex]=useState<number>(0);
  const moveList = (num:number)=>{
    const element= document.getElementById(elementIdPrefix+num);
    if(element){
      element.scrollIntoView({behavior: "smooth", block: "nearest", inline: "start"});
      setCurrentIndex(num);
    }
  }
  return (
    <div className={`${prefix}`}>
      <div className={`${prefix}-item`}>
        <div className={`${prefix}-item-title`}>
          {data.title}
          <div className={`${prefix}-item-title-btns`}>
            
            {
              data?.children&&data?.children.length>3&&<>
              
                <Button size="small" disabled={currentIndex <= 0} shape="circle" onClick={()=>moveList(currentIndex-1)}>
                  <div className="arrow-left"></div>
                </Button>
                <Button size="small" disabled={currentIndex >= data?.children?.length-3} shape="circle" onClick={()=>moveList(currentIndex+1)}>
                  <div className="arrow-right"></div>
                </Button>
              </>
            }
            
          </div>
        </div>
        <div className={`${prefix}-item-cards`}>
          <div className={`${prefix}-item-cards-contain`}>
            {data?.children?.map((card, index) => {
              return <ResourceOverviewCard key={card.id} data={card} elementId={elementIdPrefix+index} />;
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default React.memo(ResourceOverviewList);
